var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.173,
    height: 12.526,
    viewBox: "0 0 14.173 12.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M3.293,42.68V36.917a.8.8,0,0,0-.823-.8H.823a.819.819,0,0,0-.823.8v5.74a.8.8,0,0,0,.823.8H2.47a.747.747,0,0,0,.823-.777Zm9.88-5.737a1.235,1.235,0,0,0-1.235-1.234H8.169a6.28,6.28,0,0,0,.888-2.47A1.244,1.244,0,0,0,7.783,32C6.159,32,7.1,33.959,5,35.643l-.419.334a1.24,1.24,0,0,0-.461.962h0v4.117a1.235,1.235,0,0,0,.494.988l.878.658a4.1,4.1,0,0,0,2.469.824h1.51a1.227,1.227,0,0,0,1.2-1.506,1.222,1.222,0,0,0,.672-1.81,1.227,1.227,0,0,0,.68-2.041,1.231,1.231,0,0,0,1.15-1.227Z",
    transform: "translate(13.673 44.026) rotate(180)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlik);
export default __webpack_public_path__ + "static/media/unlik.421ce06dc083e9e785da2d9e9329c52d.svg";
export { ForwardRef as ReactComponent };